import React, { useState } from 'react';
import AllInquiryList from '../../components/AdminSideComponents/Inquiry/AllInquiryList';


const Inquiry = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-800">Inquiries</h1>
        <p className="text-sm text-gray-500 mt-1">View and manage all customer inquiries</p>
      </div>

      <AllInquiryList />
    </div>
  );
};

export default Inquiry;